import { gql } from "lib/apolloClient";
import { courseListFragments, fragments } from "./RoutineTemplatesFragments";

export const getRoutineTemplatesQuery = gql`
  query getOrganizationPostTemplate(
    $organizationId: ID!
    $filters: OrganizationPostTemplateFilter
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        postTemplate(filters: $filters) {
          id
          title
          updatedAt
          updatedBy {
            id
            firstName
            lastName
          }
          entityMap(filters: { entityTypes: [COURSE, CURRICULUM_PROGRAM] }) {
            id
            entityType
            entity {
              id
              ...courseItem
            }
          }
        }
      }
      __typename
    }
  }
  ${fragments.templateCourseItem}
`;

export const getCourseListQuery = gql`
  query getCourseList($organizationId: ID!, $filters: CourseFilterInput) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        ...organizationCourseItem
      }
    }
  }
  ${courseListFragments.organizationCourseList}
`;

export const getMealTemplatesQuery = gql`
  query getMealTemplates(
    $organizationId: ID!
    $filters: OrganizationPostTemplateDataSetFilter
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        postTemplateDataSet(filters: $filters) {
          id
          title
          type
          startDate
          endDate
        }
      }
    }
  }
`;

export const getOrganizationGradesQuery = gql`
  query getOrganizationGrades($id: ID!, $filters: GradeFilterInput) {
    node(id: $id, type: ORGANIZATION) {
      ... on Organization {
        id
        grades(filters: $filters) {
          id
          name
          displaySequence
        }
      }
    }
  }
`;
